export enum IntegrationEnum {
  POINT_OF_SALES = "POINT_OF_SALES",
}
